import { getFreeBottleFromDiscounts, isDiscountsPresentInCart } from '@vivino/js-web-common';
import { RubyLibCartFull } from '@webtypes/rubyLibApi';
import React from 'react';

import FreeBottleDiscountBannerPresentational from './FreeBottleDiscountBanner.presentational';

interface FreeBottleDiscountBannerContainerProps {
  cart: RubyLibCartFull;
  className?: string;
  bottleCount?: number;
}

const getFreeBottleDiscountProps = (freeBottleDiscount) => {
  const { max_amount, bottles_required } = freeBottleDiscount.parameters;

  return {
    maxAmount: max_amount,
    bottlesRequired: bottles_required,
  };
};

const FreeBottleDiscountBanner = ({
  cart,
  className,
  bottleCount = 0,
}: FreeBottleDiscountBannerContainerProps) => {
  if (!isDiscountsPresentInCart(cart)) {
    return null;
  }

  const freeBottleDiscount = getFreeBottleFromDiscounts(cart.discounts);

  if (!freeBottleDiscount) {
    return null;
  }

  return (
    <FreeBottleDiscountBannerPresentational
      currency={cart.currency}
      className={className}
      bottleCount={bottleCount}
      {...getFreeBottleDiscountProps(freeBottleDiscount)}
    />
  );
};

export default FreeBottleDiscountBanner;
